import React from "react";
import {
  Squares2X2Icon,
  Bars3Icon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

import { metricOptions } from "./metrics";

export const VIEWS = [
  { id: "traffic", label: "Traffic" },
  { id: "organic", label: "Organic" },
  { id: "speed", label: "Page speed" },
  { id: "audits", label: "Audits" },
  { id: "growth", label: "Pages & deploys" },
  { id: "indexing", label: "Indexing" },
];

export const RANGES = [
  { days: 7, label: "7D" },
  { days: 28, label: "28D" },
  { days: 90, label: "90D" },
];

export const SORTS = [
  { id: "value", label: "Sort value" },
  { id: "change", label: "Sort change" },
  { id: "name", label: "Sort name" },
];

const Toolbar = ({
  view,
  days,
  onDaysChange,
  metric,
  onMetricChange,
  sort,
  onSortChange,
  layout,
  onLayoutChange,
  showRange = true,
}) => {
  const metrics = metricOptions(view);

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="flex flex-wrap items-center gap-1.5">
        {VIEWS.map((item) => {
          const active = item.id === view;
          return (
            <Link
              key={item.id}
              to={`/analytics/${item.id}/?days=${days}`}
              className={`rounded-lg px-3 py-1.5 text-[13px] font-medium transition-colors ${
                active
                  ? "bg-theme-text text-theme-main"
                  : "text-theme-text opacity-60 hover:opacity-100 hover:bg-black hover:bg-opacity-5"
              }`}
            >
              {item.label}
            </Link>
          );
        })}
      </div>

      <div className="ml-auto flex flex-wrap items-center gap-2">
        {metrics.length > 1 && (
          <select
            value={metric || metrics[0].id}
            onChange={(event) => onMetricChange(event.target.value)}
            className="rounded-lg border border-theme-secondary bg-theme-main px-2.5 py-1.5 text-xs text-theme-text"
            aria-label="Metric"
          >
            {metrics.map((item) => (
              <option key={item.id} value={item.id}>
                {item.label}
              </option>
            ))}
          </select>
        )}

        {showRange && (
          <div className="flex items-center rounded-lg border border-theme-secondary p-0.5">
            {RANGES.map((range) => (
              <button
                key={range.days}
                type="button"
                onClick={() => onDaysChange(range.days)}
                className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${
                  days === range.days
                    ? "bg-theme-secondary text-theme-text"
                    : "text-theme-text opacity-55 hover:opacity-90"
                }`}
              >
                {range.label}
              </button>
            ))}
          </div>
        )}

        <select
          value={sort}
          onChange={(event) => onSortChange(event.target.value)}
          className="rounded-lg border border-theme-secondary bg-theme-main px-2.5 py-1.5 text-xs text-theme-text"
        >
          {SORTS.map((item) => (
            <option key={item.id} value={item.id}>
              {item.label}
            </option>
          ))}
        </select>

        <div className="flex items-center rounded-lg border border-theme-secondary p-0.5">
          <button
            type="button"
            onClick={() => onLayoutChange("grid")}
            className={`rounded-md p-1.5 transition-colors ${
              layout === "grid" ? "bg-theme-secondary text-theme-text" : "text-theme-text opacity-55"
            }`}
            aria-label="Grid view"
          >
            <Squares2X2Icon className="h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={() => onLayoutChange("list")}
            className={`rounded-md p-1.5 transition-colors ${
              layout === "list" ? "bg-theme-secondary text-theme-text" : "text-theme-text opacity-55"
            }`}
            aria-label="List view"
          >
            <Bars3Icon className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Toolbar;
